import { render } from "./MdDialogConfirm.vue?vue&type=template&id=e05b1b5a"
import script from "./MdDialogConfirm.vue?vue&type=script&lang=js"
export * from "./MdDialogConfirm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__